import React from 'react'
import { UnstyledButton } from '@chilipiper/design-system/src/new'
import { Box, Icon, styled, Text } from '@chilipiper/design-system'
import { useIsDesktop } from '../useIsDesktop'

type Props = {
  icon: React.ComponentType
  isSelected: boolean
  onClick: () => void
  text: string
}

export const Feature = ({ text, icon, isSelected, onClick }: Props) => {
  const isDesktop = useIsDesktop()
  if (!isDesktop) {
    return (
      <Box
        display='flex'
        onClick={onClick}
        borderRadius={8}
        alignItems='flex-start'
        p={5}
        bg='bg/list-item-default'
        boxShadow='border/section'
      >
        <FeatureContent isSelected={false} text={text} icon={icon} />
      </Box>
    )
  }
  const isVisiblySelected = isDesktop && isSelected

  return (
    <StyledButton
      display='flex'
      onClick={onClick}
      borderRadius={8}
      alignItems='flex-start'
      p={5}
      isSelected={isVisiblySelected}
    >
      <FeatureContent isSelected={isVisiblySelected} text={text} icon={icon} />
    </StyledButton>
  )
}

const FeatureContent = ({
  isSelected,
  icon,
  text,
}: {
  icon: React.ComponentType
  isSelected: boolean
  text: string
}) => {
  return (
    <>
      <Box
        borderRadius='full'
        bg={isSelected ? 'bg/action-bar-button-major-active' : 'bg/action-bar-button-minor-active'}
        p='6px'
        mr={3}
      >
        <Icon icon={icon} w={3} h={3} color={isSelected ? 'fg/action' : 'fg/moderate'} />
      </Box>
      <Text
        color='fg/major'
        textStyle='body-multiline-tight'
        fontWeight={isSelected ? 600 : undefined}
      >
        {text}
      </Text>
    </>
  )
}

const StyledButton = styled(UnstyledButton)<{ isSelected?: boolean }>`
  transition: all 0.2s;
  box-shadow: ${({ theme, isSelected }) =>
    isSelected ? theme.shadows['border/card-item-selected'] : theme.shadows['border/section']};
  background: ${({ theme, isSelected }) =>
    isSelected ? theme.colors['bg/list-item-selected'] : theme.colors['bg/list-item-default']};
  &:hover {
    box-shadow: ${({ theme, isSelected }) =>
      isSelected
        ? theme.shadows['border/card-item-selected']
        : theme.shadows['border/card-item-hovered']};
  }
`
